/* ------------------------------------------------------------------
   Global stack of “closable” callbacks.
   The top-most UI layer (bottom-sheet, drawer, etc.) registers its
   own close handler; the Jobs-app back gesture tries to fire it first.
   ------------------------------------------------------------------ */

const stack = [];          // LIFO order – last pushed = top-most sheet

export const pushCloser  = (fn) => fn && stack.push(fn);  // ignore falsy
export const popCloser   = ()    => { stack.pop(); };
export const clearClosers= ()    => { stack.length = 0; };
export const hasClosers  = ()    => stack.length > 0;

/**
 * Attempt to close the top-most temporary UI.
 * @returns {boolean} true if something was closed, false otherwise
 */
export const tryCloseTop = () => {
  const fn = stack[stack.length - 1];
  if (!fn) return false;          // nothing registered
  try { fn(); } finally { stack.pop(); }
  return true;
};
